import { render, staticRenderFns } from "./BimMonitor.vue.html?vue&type=template&id=31688954&lang=html&external"
import script from "./BimMonitor.vue.js?vue&type=script&lang=js&external"
export * from "./BimMonitor.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimMonitor.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports